import { render, staticRenderFns } from "./Q8.vue?vue&type=template&id=b3822162&"
import script from "./Q8.vue?vue&type=script&lang=ts&"
export * from "./Q8.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports